import React, { FC } from 'react';
import { ReportDialogOptions, Scope, ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import ErrorMessage from '@minecraft.error-message';

type EBProps = {
  showDialog?: boolean;
  dialogOptions?: ReportDialogOptions;
  fallback?: React.ReactNode;
  onError?(error: Error, componentStack: string, eventId: string): void;
  onMount?(): void;
  onUnmount?(error: Error | null, componentStack: string | null, eventId: string | null): void;
  onReset?(error: Error | null, componentStack: string | null, eventId: string | null): void;
  beforeCapture?(scope: Scope, error: Error, componentStack: string): void;
  children: React.ReactNode;
};

const ErrorBoundary: FC<EBProps> = ({ children, ...rest }) => {
  return (
    <SentryErrorBoundary {...rest} fallback={({ error }): JSX.Element => <ErrorMessage error={error} />}>
      {children}
    </SentryErrorBoundary>
  );
};

export default ErrorBoundary;
